import { InputProps } from '@apia/theme';
import { Input } from '../../components';
import { ValidatedCollectorField } from '../ValidatedCollectorField';

export class CollectorInput extends ValidatedCollectorField<
  string,
  Omit<InputProps, 'name'>
> {
  type = 'input';

  Component = () => {
    const rules = this.useValidationRules();
    const validationFunction = this.useValidationFunction();
    const props = this.useProperties();

    return (
      <Input
        {...props}
        initialValue={this.config.initialValue}
        validationFunction={validationFunction}
        name={this.name}
        label={this.label}
        validationRules={rules}
      />
    );
  };
}
